import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import { handleServiceError } from './handleServiceError';

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const getBooking = async (bookingId: string, options: Options = {}): Promise<SelfServiceAPI.GetBooking.Response> => {
  try {
    const { data } = await axios.get<SelfServiceAPI.GetBooking.Response>(`${SELF_SERVICE_API_URL}/bookings/${bookingId}`, {
      withCredentials: true,
    });

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await getBooking(bookingId, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `GET /bookings/${bookingId}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getBooking;
